/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Aside_AriaInputs */

const en_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image inspector`)
};

const ar_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فاحص الصور`)
};

const bn_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমেজ ইন্সপেক্টর`)
};

const de_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bild-Inspektor`)
};

const es_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspector de imagen`)
};

const fr_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspecteur d'image`)
};

const pt_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspetor de imagem`)
};

const zh_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图片检查器`)
};

const tr_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görsel denetçisi`)
};

const ru_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инспектор изображения`)
};

const pl_image_inspector_aside_aria = /** @type {(inputs: Image_Inspector_Aside_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor obrazu`)
};

/**
* | output |
* | --- |
* | "Image inspector" |
*
* @param {Image_Inspector_Aside_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_aside_aria = /** @type {((inputs?: Image_Inspector_Aside_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Aside_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_aside_aria(inputs)
	if (locale === "bn") return bn_image_inspector_aside_aria(inputs)
	if (locale === "de") return de_image_inspector_aside_aria(inputs)
	if (locale === "es") return es_image_inspector_aside_aria(inputs)
	if (locale === "fr") return fr_image_inspector_aside_aria(inputs)
	if (locale === "pt") return pt_image_inspector_aside_aria(inputs)
	if (locale === "zh") return zh_image_inspector_aside_aria(inputs)
	if (locale === "tr") return tr_image_inspector_aside_aria(inputs)
	if (locale === "ru") return ru_image_inspector_aside_aria(inputs)
	if (locale === "pl") return pl_image_inspector_aside_aria(inputs)
	return en_image_inspector_aside_aria(inputs)
});